import { faker } from '@faker-js/faker';

const EMPTY = '';

const ARTICLE = {
  article_id: 196722,
  section_id: 43031,
  section_id_arr: ['43031'],
  article_title: EMPTY,
  article_content: EMPTY,
  article_tags: EMPTY,
  access_type: 'public',
  active: true,
  created_at: 'Tue, 23 Jun 2020 16:13:53 +0300',
  updated_at: 'Tue, 23 Jun 2020 16:13:53 +0300'
};

export const articles = [
  {
    category_id: 16925,
    category_title: 'Инструкции',
    active: true,
    created_at: 'Wed, 03 Jul 2019 15:54:44 +0300',
    updated_at: 'Tue, 23 Jun 2020 16:46:06 +0300',
    sections: [
      {
        section_id: 43031,
        category_id: 16925,
        section_title: 'Общие инструкции - видео',
        section_description:
          'Видео инструкции по монтажу оборудования, обзоры оборудования, обслуживание оборудования',
        active: true,
        created_at: 'Mon, 16 Sep 2019 09:39:16 +0300',
        updated_at: 'Tue, 04 Mar 2025 09:36:18 +0300',
        articles: faker.helpers.uniqueArray(
          () => ({ ...ARTICLE, article_id: faker.number.int() }),
          53
        )
      },
      {
        section_id: 46963,
        category_id: 16925,
        section_title: 'Общие инструкции на оборудование',
        section_description:
          'Инструкции по эксплуатации и паспорта на наши аппараты. \n Улица, Фрост, Подъезд, Киоск, Онлайн',
        active: true,
        created_at: 'Tue, 23 Jun 2020 16:47:55 +0300',
        updated_at: 'Tue, 04 Mar 2025 09:34:24 +0300',
        articles: faker.helpers.uniqueArray(
          () => ({ ...ARTICLE, article_id: faker.number.int() }),
          14
        )
      },
      {
        section_id: 46964,
        category_id: 16925,
        section_title: 'Все о платежных системах',
        section_description:
          'Инструкции с фотографиями и описанием порядка обслуживания отдельных узлов и агрегатов оборудования',
        active: true,
        created_at: 'Tue, 23 Jun 2020 16:48:52 +0300',
        updated_at: 'Tue, 04 Mar 2025 09:32:57 +0300',
        articles: faker.helpers.uniqueArray(
          () => ({ ...ARTICLE, article_id: faker.number.int() }),
          9
        )
      },
      {
        section_id: 74748,
        category_id: 16925,
        section_title: 'Мой первый запуск',
        section_description:
          'В данном разделе вы найдете все базовые знания, для того, что бы начать работать новичку',
        active: true,
        created_at: 'Thu, 30 Jan 2025 15:14:13 +0300',
        updated_at: 'Thu, 06 Feb 2025 09:13:15 +0300',
        articles: faker.helpers.uniqueArray(
          () => ({ ...ARTICLE, article_id: faker.number.int() }),
          1
        )
      }
    ]
  },
  {
    category_id: 17070,
    category_title: 'Сервис и поддержка',
    active: true,
    created_at: 'Thu, 25 Jul 2019 16:25:50 +0300',
    updated_at: 'Wed, 18 Sep 2024 14:16:53 +0300',
    sections: [
      {
        section_id: 41944,
        category_id: 17070,
        section_title: 'Общая информация',
        section_description:
          'Служба поддержки, покупка запасных частей, макеты полиграфической продукции, информационные материалы, маркетинговые материалы',
        active: true,
        created_at: 'Wed, 03 Jul 2019 15:54:44 +0300',
        updated_at: 'Tue, 04 Mar 2025 09:37:51 +0300',
        articles: faker.helpers.uniqueArray(
          () => ({ ...ARTICLE, article_id: faker.number.int() }),
          12
        )
      },
      {
        section_id: 47111,
        category_id: 17070,
        section_title: 'Маркетинговая поддержка',
        section_description:
          'Советы опытных маркетологов, которые помогут вам выбрать место для аппарата, поднять трафик и тд.',
        active: true,
        created_at: 'Tue, 07 Jul 2020 15:19:01 +0300',
        updated_at: 'Wed, 07 Sep 2022 14:07:08 +0300',
        articles: faker.helpers.uniqueArray(
          () => ({ ...ARTICLE, article_id: faker.number.int() }),
          17
        )
      },
      {
        section_id: 48380,
        category_id: 17070,
        section_title: 'Юридическая поддержка',
        section_description:
          'Обзор действующего законодательства, связанного с деятельностью вендингового оборудования (Водоматов). Образцы заявлений, шаблоны документов.',
        active: true,
        created_at: 'Wed, 14 Oct 2020 13:37:40 +0300',
        updated_at: 'Tue, 04 Mar 2025 09:39:03 +0300',
        articles: faker.helpers.uniqueArray(
          () => ({ ...ARTICLE, article_id: faker.number.int() }),
          9
        )
      },
      {
        section_id: 48439,
        category_id: 17070,
        section_title: 'Полиграфическая поддержка',
        section_description: '',
        active: true,
        created_at: 'Fri, 16 Oct 2020 13:24:45 +0300',
        updated_at: 'Wed, 07 Sep 2022 14:07:10 +0300',
        articles: faker.helpers.uniqueArray(
          () => ({ ...ARTICLE, article_id: faker.number.int() }),
          1
        )
      }
    ]
  },
  {
    category_id: 24934,
    category_title: 'Внутренний раздел',
    active: true,
    created_at: 'Fri, 02 Sep 2022 13:24:42 +0300',
    updated_at: 'Thu, 30 Jan 2025 15:11:55 +0300',
    sections: []
  },
  {
    category_id: 24967,
    category_title: 'aliveWiki',
    active: true,
    created_at: 'Wed, 07 Sep 2022 18:03:17 +0300',
    updated_at: 'Wed, 07 Sep 2022 18:03:35 +0300',
    sections: []
  }
];
